import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class UserModel extends BaseModel {

    constructor() {
        super({ 
                name: "account",
                tableName: 'accounts', 
                label: "Quản lý người dùng", 
                // display_key: 'fullname', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            account: { 
                name: 'account', 
                type: "String", 
                label: 'Account', 
                sortable: false, 
                // filter: { type: 'input', match: 'contains'},
            },
            type: {
                name: 'type', 
                type: "String",
                label: 'Type',
                // filter: { type: 'input', match: 'contains'},
                // display: false
            },
            relation: { 
                name: "relation", 
                label: "Người dùng", 
                width: 18,
                // filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.relation = (data.users !== undefined && data.users !== null) ? data.users.fullname : '';
                }
            },
            uid: { 
                name: 'uid',
                refs: 'users { id fullname str_code_agency }',
                display: false
            }
        },)
    }

}